
import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/navBar.vue";
import imgChange from "./index.js";
@Component({
  components: {
    NavBar
  },
})
export default class Logout extends Vue {
  public regularData = {
    title: "",
    content: "",
  };
  public url = this.$HTTP_API.user.getHelp;
  public mounted() {
    this.getHelp();
  }

  public async getHelp() {
    const res = await imgChange(this.url);
    this.regularData.title = res.title;
    this.regularData.content = res.data;
  }
}
